const IMPORTED_IMAGE_TYPES = ['automaticExport', 'commandLine'];
export const isImportedImage = ({ origin }: { origin?: string } = {}) =>
  IMPORTED_IMAGE_TYPES.includes(origin);
